import React from "react";
import withStyles from "components/with-styles";
import styles from "./styles/footer.css.js";

const Footer = ({ children, classes }) =>
  children ? (
    <div className={classes.footer}>
      <div className={classes.footer_content}>{children}</div>
    </div>
  ) : null;

export default withStyles(styles)(Footer);
